import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from '../admin.service';

import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-social-hub-main',
  templateUrl: './social-hub-main.component.html',
  styleUrls: ['./social-hub-main.component.css']
})
export class SocialHubMain implements OnInit {
  sortingType: string = "OPEN";
  competitions: any;
  sortIconStartTimeSrc: string = "assets/uparrow.svg";
  sortIconEndTimeSrc: string = "assets/uparrow.svg";
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  hasCompetitionZoneAccess: boolean = false;
  hasPostHubAccess: boolean = false;
  
  constructor(private route: ActivatedRoute, private router: Router, private adminService: AdminService, private _matDialog: MatDialog, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    const adminFeatureList = sessionStorage.getItem('adminFeatureList');
    if (adminFeatureList) {
      const features = JSON.parse(adminFeatureList);
      this.hasCompetitionZoneAccess = features.includes('competitions');
      this.hasPostHubAccess = features.includes('posts');
    }
    this.sortingType = this.route.snapshot.params.status || 'OPEN';
    this.getAllCompetitions();
  }

  getAllCompetitions() {
    this.adminService
      .getAllCompetitions(this.sortingType)
      .subscribe((response) => {
        this.competitions = response.competitions;
      });
  }

  sortAccToStartTime() {
    if (this.sortIconStartTimeSrc === "assets/uparrow.svg") {
      this.sortIconStartTimeSrc = 'assets/down-arrow.svg'
      this.competitions.sort((a, b) => {
        const startTimeA = new Date(a.start_time).getTime();
        const startTimeB = new Date(b.start_time).getTime();
        return startTimeA - startTimeB;
      });
    }
    else {
      this.sortIconStartTimeSrc = 'assets/uparrow.svg'
      this.competitions.sort((a, b) => {
        const startTimeA = new Date(a.start_time).getTime();
        const startTimeB = new Date(b.start_time).getTime();
        return startTimeB - startTimeA;
      });
    }

  }

  sortAccToEndTime() {
    if (this.sortIconEndTimeSrc === 'assets/uparrow.svg') {
      this.sortIconEndTimeSrc = 'assets/down-arrow.svg'
      this.competitions.sort((a, b) => {
        const startTimeA = new Date(a.end_time).getTime();
        const startTimeB = new Date(b.end_time).getTime();
        return startTimeA - startTimeB;
      });
    }
    else {
      this.sortIconEndTimeSrc = 'assets/uparrow.svg'
      this.competitions.sort((a, b) => {
        const startTimeA = new Date(a.end_time).getTime();
        const startTimeB = new Date(b.end_time).getTime();
        return startTimeB - startTimeA;
      });
    }
  }

  openReschedulePopUp(title: any, startTime: any, competition_uuid: any) {
    const dialogRef = this._matDialog.open(ResheduleDialog, {
      data: { title: title, dateTime: startTime },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data?.updatedTime) {
        let resheduleDateTime = result.data?.updatedTime;
        this.rescheduleDate(resheduleDateTime, competition_uuid);
      }
    })
  }

  rescheduleDate(resheduleDateTime, competition_uuid) {
    this.adminService.resheduleCompetition(competition_uuid, { start_time: resheduleDateTime })
      .subscribe(
        (response) => { 
          this._snackBar.open("Successfully Reshedule", 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          })
        },
        (error) => {
          this._snackBar.open(error.error.message, 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
        }
        
      )
  }
 deleteCompetition(title,id){
    const dialogRef = this._matDialog.open(DeleteDialog, {
       data: { title,id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data?.isDeleted) {
        this.getAllCompetitions();
        this._snackBar.open("Successfully Deleted", 'close', {
          duration: 3000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
        })
      }
    })
  } 
}

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.html',
  styleUrls: ['./social-hub-main.component.css']
})

export class DeleteDialog{
  title = ""
  id = '';
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(public dialogRef: MatDialogRef<DeleteDialog>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private adminService: AdminService, private _snackBar: MatSnackBar) {
    this.title = data.title
    this.id = data.id
  }
  closePopUp(){
    this.dialogRef.close();
  }
  deleteCompetition(){
    this.adminService.deleteCompetition(this.id).subscribe(
      (res) => {}, 
      (error) => {
        if(error.status == 200){
          this.dialogRef.close({
            event: 'close',
            data: {
              isDeleted:true
            }
          });
        }
        else {
          let message = error.error.message ? error.error.message : "Something Went Wrong, Delete Failed";
          this._snackBar.open(message, 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
        }
      }
    )
  }
}


@Component({
  selector: 'app-rescedule-dialog',
  templateUrl: './reschedule-dialog.html',
  styleUrls: ['./social-hub-main.component.css']
})

export class ResheduleDialog implements OnInit {
  title: string = "";
  minDate: Date;
  maxDate: Date;
  times: string[] = ["09:00 am", "12:00 pm", "03:00 pm", "06:00 pm"];
  selected: string;
  date = new FormControl();
  intialDate = "";
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(public dialogRef: MatDialogRef<ResheduleDialog>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any, private adminService: AdminService, private _snackBar: MatSnackBar) {
    this.title = data.title;
    this.date.setValue(data.dateTime);
    this.intialDate = data.dateTime
    const currentYear = new Date().getFullYear();
    this.minDate = new Date();
    this.maxDate = new Date(currentYear + 1, 11, 31);
    this.selected = this.constructTimeFromTimeStamp(data.dateTime)
  }


  constructTimeFromTimeStamp(time) {
    const date = new Date(time);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;
    const formattedTime = `${formattedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    return formattedTime;
  }


  ngOnInit(): void {

  }
  closePopup() {
    this.dialogRef.close();
  }

  resheduleDateTime() {
    const dateValue = new Date(this.date.value);
    const timeValue = this.selected;
    let [hours, minutes] = timeValue.split(':');
    const isPM = timeValue.toLowerCase().includes('pm');

    if (isPM && hours !== '12') {
      hours = String(parseInt(hours, 10) + 12);
    }

    dateValue.setHours(parseInt(hours, 10), parseInt(minutes, 10));

    // const formattedDate = dateValue.toISOString().replace('Z', '.000');
    const formattedDate = dateValue.toISOString();

    if (formattedDate == this.intialDate) {
      this._snackBar.open('Nothing Changed', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
      return;
    }
    else {
      this.dialogRef.close({
        event: 'close',
        data: {
          updatedTime: formattedDate
        }
      });
    }
  }

}

